'use client';

import { useTranslations } from 'next-intl';
import { useState, useEffect } from 'react';

import { FeatureProductFormSubscribe } from '@/fo/feature/product/form/subscribe';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { utilEventProductSubscribeModal } from '@/fo/util/event-product-subscribe-modal';

import { styles } from './FeatureProductModalSubscribe.styles';

export function FeatureProductModalSubscribe() {
  const slots = styles();
  const t = useTranslations();
  const [open, setOpen] = useState(false);
  const [productId, setProductId] = useState('');

  useEffect(() => {
    const unsubscribeOnOpen = utilEventProductSubscribeModal.onOpen((id) => {
      setProductId(id);
      setOpen(true);
    });
    const unsubscribeOnClose = utilEventProductSubscribeModal.onClose(() =>
      setOpen(false)
    );

    return () => {
      unsubscribeOnOpen();
      unsubscribeOnClose();
    };
  }, []);

  return (
    <UiKitDrawerBase
      title={t('Find out about admission')}
      open={open}
      direction="right"
      onOpenChange={setOpen}
    >
      <div className={slots.title()}>{t('Find out about admission')}</div>

      <FeatureProductFormSubscribe productId={productId} />
    </UiKitDrawerBase>
  );
}
